import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';
import { QuestionInterface } from '../../../lib/type';
import { Button } from 'carbon-components-react';
import { ArrowRight20 } from '@carbon/icons-react';
import './Question.scss';
import { useContext, useEffect, useState } from 'react';
import { layoutContext } from '../../LeaderAssesssment';

interface questionsProps {
  contents: QuestionInterface;
  totalOfQuestions: number;
  qNextBtn: object;
  lastQuestion: number;
}

const MultipleChoiceQuestion = (questionsProps: questionsProps) => {
  const { contents, totalOfQuestions, qNextBtn, lastQuestion } = questionsProps;
  const [t, setT] = useState(true);
  const {
    setCurrentQuestion,
    currentQuestion,
    selectedAnswers,
    setSelectedAnswers,
  } = useContext(layoutContext);

  const handleClick = (selected: any, option: any) => {
    setT(!t);

    if (!selected.includes(option)) {
      if (selected.length < 5) {
        selected.push(option);

        setSelectedAnswers(selected);
      }
    } else {
      const filtered = selected.filter((op: any) => op !== option);
      setSelectedAnswers(filtered);
    }
  };

  const handleKeys = (key: any, option: any) => {
    if (key === 'Enter' || key === 'Spacebar' || key === ' ') {
      handleClick(selectedAnswers, option);
    }
  };

  const handleNext = (currentNumber: number) => {
    setCurrentQuestion((currentNumber += 1));
  };

  return (
    <div className="leadership-assesssment__question bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
      <ProgressBar
        label={`${contents.questionNumber} of ${totalOfQuestions}`}
        value={(contents.questionNumber - 1) / totalOfQuestions}
        max={1}
        className="leadership-assesssment__question-progress"
      />
      <h1 className="leadership-assesssment__question-title">{`${contents.questionNumber}. ${contents.title.props.defaultMessage}`}</h1>
      <h4 className="leadership-assesssment__question-subTitle">
        {contents.subTitle}
      </h4>
      <div className="leadership-assesssment__question-options">
        {contents.options.map((option, i) => {
          return (
            <p
              className={
                selectedAnswers.includes(option)
                  ? 'leadership-assesssment__question-option-selected leadership-assesssment__question-option'
                  : selectedAnswers.length !== 5
                  ? 'leadership-assesssment__question-option'
                  : 'leadership-assesssment__question-option leadership-assesssment__question-option-desabled'
              }
              onClick={() => handleClick(selectedAnswers, option)}
              tabIndex={i + 1}
              onKeyUp={(e: any) => handleKeys(e.key, option)}
            >
              {option.copy}
            </p>
          );
        })}
      </div>
      <div className="leadership-assesssment__question-btn-container">
        <Button
          className="leadership-assesssment__question-btn"
          disabled={selectedAnswers.length !== 5}
          onClick={() => handleNext(currentQuestion)}
        >
          {qNextBtn}
          <ArrowRight20 />
        </Button>
      </div>
    </div>
  );
};

export default MultipleChoiceQuestion;
